import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [logoSrc, setLogoSrc] = useState(require('../assets/loov-logo-1.svg').default);

  // Scroll event to change logo
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setLogoSrc(require('../assets/loov-logo-2.svg').default);
      } else {
        setLogoSrc(require('../assets/loov-logo-1.svg').default);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const setupNavbar = async () => {
      if (typeof window !== 'undefined') {
        // Dynamically import Collapse from Bootstrap's actual file
        const Collapse = (await import('bootstrap/js/dist/collapse')).default;

        const navLinks = document.querySelectorAll('.navbar-collapse .nav-link');
        const navbarCollapse = document.getElementById('navbarNavAltMarkup');

        if (!navbarCollapse) return;

        navLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (navbarCollapse.classList.contains('show')) {
              const collapse = new Collapse(navbarCollapse);
              collapse.hide();
            }
          });
        });
      }
    };

    setupNavbar();
  }, []);

  return (
      <nav className="navbar navbar-expand-lg position-sticky top-0 px-xl-3 px-lg-1 header-bg" style={{ zIndex: 9999 }}>
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logoSrc} alt="Logo" height="50" id="navbar-logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
            <div className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <Link className={`nav-link text-black ${currentPath === '/' ? 'active' : ''}`} to="/">Home</Link>
                            <Link className={`nav-link text-black ${currentPath.startsWith('/about-us') ? 'active' : ''}`} to="/about-us">About Us</Link>
              <Link className={`nav-link text-black ${currentPath.startsWith('/pricing') ? 'active' : ''}`} to="/pricing">Pricing</Link>
              {/* <Link className={`nav-link text-black ${currentPath.startsWith('/contact') ? 'active' : ''}`} to="/contact">Contact Us</Link> */}
              <a className="text-decoration-none nav-link d-flex justify-content-center" target='_blank' rel="noopener noreferrer"  href="https://view.loov.in/sign-up">
                <button className="Free_Trail">Start Free Trail </button>
              </a>
             

             
              <a className="text-decoration-none nav-link d-flex justify-content-center" target='_blank' rel="noopener noreferrer" href="https://view.loov.in/sign-in">
                <button className="sign_In">Sign In</button>
              </a>
              {/* {!currentPath.startsWith('/pricing') && 
              <Link className="nav-link text-black" to="https://view.loov.in/sign-in" target='_blank' rel="noopener noreferrer">Login</Link>
              }
              */}
              {/* <a className="text-decoration-none nav-link d-flex justify-content-center" target='_blank' rel="noopener noreferrer" href="https://view.loov.in/sign-up">
                <button className="sign_btn">Sign Up</button>
              </a> */}
            </div>
          </div>
        </div>
      </nav>
  )
}

export default Header
